module.exports = "/images/avg-time.a60e7b955531b972216445b2e64ae494.svg";